import { useCallback, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import api from "../../components/utils/api"
import TrainingProgressView from "./TrainingProgressView"

// Progress of the base model training during DB generation, looked up by
// CochlDB id.
const DBTrainingProgressPage = () => {
    const params = useParams()
    const [progress, setProgress] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState(null)

    const fetchProgress = useCallback(async () => {
        setIsLoading(true)
        setError(null)
        try {
            const res = await api.get(`/api/dbs/${params.id}/training-progress`)
            setProgress(res.data)
        } catch (err) {
            console.error(err)
            setError(err.response?.data?.message ?? 'Failed to fetch training progress')
        } finally {
            setIsLoading(false)
        }
    }, [params.id])

    useEffect(() => { fetchProgress() }, [fetchProgress])

    return <TrainingProgressView progress={progress} isLoading={isLoading} error={error} onRefresh={fetchProgress} />
}

export default DBTrainingProgressPage
